import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/shared/PageHeader';
import ActiveCourseSelect from '@/components/student-dashboard/ActiveCourseSelect';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useNewUiScope from '@/data/hook/shared/useNewUiScope';
import User from '@/models/User';

type StudentDashboardHeaderSectionProps = {
  user: User;
};

export default function StudentDashboardHeaderSection({
  user,
}: StudentDashboardHeaderSectionProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentDashboard.header',
  });
  const isAppShellEnabled = useNewUiScope('appShell');

  return (
    <ConditionalRenderer condition={!isAppShellEnabled}>
      <PageHeader className="min-w-0 md:h-fit lg:py-4">
        <PageHeader.Row className="md:flex-nowrap md:justify-between">
          <PageHeader.Title className="min-h-16 truncate text-xl leading-16 lg:min-h-auto lg:text-4xl lg:leading-12">
            {t('hello')} <span className="text-primary">{user.firstName}</span>
          </PageHeader.Title>
          <PageHeader.Actions className="md:mr-10 lg:mr-0">
            <ActiveCourseSelect />
          </PageHeader.Actions>
        </PageHeader.Row>
      </PageHeader>
    </ConditionalRenderer>
  );
}
